import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { propMatch } from '@/helpers/custom-prop-types';
import { documentListPath, documentOnePath } from '@/utils/router/links';
import { API_GET_ONE_DOCUMENT_DOWNLOAD_REQUEST, apiGetOneDocumentDownloadRequest, } from '../../../actions/DocumentActions';
import { isGuest } from '../../../helpers/auth';
import { isLoading } from '../../../helpers/fetch';
import CustomRedirect from '../../../route/CustomRedirect';
import AppLoading from '../../AppLoading';
import Layout from '../../Layout';
import Breadcrumb from '../../Layout/Breadcrumb';
import DocumentDownloadButton from '../Common/DocumentDownload';
import FooterFollow from '../DocumentOne/FooterFollow';
const DocumentDownload = (props) => {
    const { match: { params: { code }, }, } = props;
    // reducer処理
    const dispatch = useDispatch();
    const { auth, loading, request } = useSelector((state) => ({
        auth: state.auth,
        loading: isLoading(state, API_GET_ONE_DOCUMENT_DOWNLOAD_REQUEST, code),
        request: state.document.request[code],
    }));
    useEffect(() => {
        if (!request) {
            dispatch(apiGetOneDocumentDownloadRequest(code));
        }
    }, [code, dispatch, request]);
    const pans = useMemo(() => {
        const isGuestUser = isGuest(auth);
        const memoPans = [
            {
                link: documentListPath(),
                text: 'ダウンロード資料',
            },
        ];
        if (!isGuestUser) {
            memoPans.unshift({
                link: '/mypage',
                text: 'マイページ',
            });
        }
        if (request) {
            memoPans.push({
                link: documentOnePath(request.weightLevel, request.documentId),
                text: request.title,
            });
        }
        return memoPans;
    }, [auth, request]);
    if (!request) {
        return loading || loading === undefined ? (_jsx(AppLoading, {})) : (_jsx(CustomRedirect, { to: '/column' }));
    }
    const { documentId, title } = request;
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main document_download_container column_common_container' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `ダウンロード お役立ち資料｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsxs("div", Object.assign({ className: 'document_download_main_container' }, { children: [_jsxs("h2", Object.assign({ className: 'wbr title' }, { children: ["\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9", _jsx("wbr", {}), "\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059"] })), _jsx("p", Object.assign({ className: 'download_description' }, { children: "\u3054\u767B\u9332\u3044\u305F\u3060\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u8CC7\u6599\u3068\u4F1A\u54E1\u767B\u9332\u306EURL\u3092\u9001\u4FE1\u3044\u305F\u3057\u307E\u3057\u305F\u3002" })), _jsxs("p", Object.assign({ className: 'download_description middle_text' }, { children: ["\u4EE5\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u300C", title, "\u300D\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u4E0B\u3055\u3044\u3002"] })), _jsx("p", Object.assign({ className: 'download_description' }, { children: "\u203B\u30E1\u30FC\u30EB\u672C\u6587\u5185\u306EURL\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8A2D\u5B9A\u3044\u305F\u3060\u304F\u3068" })), _jsx("p", Object.assign({ className: 'download_description bottom_text' }, { children: "\u4ED6\u306E\u8CC7\u6599\u3092\u30D5\u30A9\u30FC\u30E0\u5165\u529B\u306A\u3057\u3067\u3001\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3044\u305F\u3060\u3051\u307E\u3059\u3002" })), _jsx("div", Object.assign({ className: 'button_row' }, { children: _jsx(DocumentDownloadButton, { code: code, id: documentId }) }))] })), _jsx(FooterFollow, { id: documentId })] })));
};
DocumentDownload.propTypes = {
    match: propMatch(),
};
export default DocumentDownload;
